export function calculateTiradorPosition(childItem: any, parentItem: any) {
  const parentMorphs = parentItem.morphs || []
  const morphAncho = parentMorphs.find((m: any) => m.name === 'Ancho')
  const morphAlto = parentMorphs.find((m: any) => m.name === 'Alto')
  const morphFondo = parentMorphs.find((m: any) => m.name === 'Fondo')
  const widthBase = morphAncho?._default ?? parentItem.width
  const widthActual = morphAncho?.default ?? parentItem.width
  const heightBase = morphAlto?._default ?? parentItem.height
  const heightActual = morphAlto?.default ?? parentItem.height
  const depthBase = morphFondo?._default ?? parentItem.thickness
  const depthActual = morphFondo?.default ?? parentItem.thickness
  let prefix = 'b'
  if (parentItem.tipoNormalizado === 'MAL' || parentItem.tipoNormalizado === 'COL') prefix = 'a'
  let Xbase, Ybase, Zbase
  const parentHand = parentItem.hand
  const isCentralHandNormal =
    parentHand === 'CN' &&
    (childItem.handPosition === 'Izquierda' || childItem.handPosition === 'Derecha')

  const isCNWithCenterPosition = parentHand === 'CN' && childItem.handPosition === 'Centro'
  let tiradorIndex = -1
  let isTirador = false
  if (isCNWithCenterPosition) {
    isTirador = childItem.typeOfSon === 'Tirador' || childItem.description === 'Tirador'

    if (isTirador) {
      const allChilds = Array.from(parentItem.childs || [])
      const currentIndex = allChilds.indexOf(childItem.id)

      if (currentIndex === 0) {
        tiradorIndex = 0
      } else if (currentIndex === 1) {
        tiradorIndex = 1
      } else {
        tiradorIndex = currentIndex
      }
    }
  }

  if (childItem.handPosition === 'Izquierda') {
    if (parentHand === 'CN') {
      const iPosX = childItem[`${prefix}iPosicionX`]
      const dPosX = childItem[`${prefix}dPosicionX`]
      const cPosX = childItem[`${prefix}cPosicionX`]

      Xbase = childItem[`${prefix}iPosicionX`]
      Ybase = childItem[`${prefix}iPosicionY`]
      Zbase = childItem[`${prefix}iPosicionZ`]
    } else if (isCentralHandNormal) {
      Xbase = childItem[`${prefix}dPosicionX`] ?? childItem[`${prefix}cPosicionX`] ?? 0
      Ybase = childItem[`${prefix}dPosicionY`] ?? childItem[`${prefix}cPosicionY`] ?? 0
      Zbase = childItem[`${prefix}dPosicionZ`] ?? childItem[`${prefix}cPosicionZ`] ?? 0
    } else {
      Xbase = childItem[`${prefix}iPosicionX`]
      Ybase = childItem[`${prefix}iPosicionY`]
      Zbase = childItem[`${prefix}iPosicionZ`]
    }
  } else if (childItem.handPosition === 'Centro') {
    if (isCNWithCenterPosition && isTirador) {
      const iPosX = childItem[`${prefix}iPosicionX`]
      const dPosX = childItem[`${prefix}dPosicionX`]
      const cPosX = childItem[`${prefix}cPosicionX`]

      Xbase = cPosX
      Ybase = childItem[`${prefix}cPosicionY`]
      Zbase = childItem[`${prefix}cPosicionZ`]
    } else {
      Xbase = childItem[`${prefix}cPosicionX`]
      Ybase = childItem[`${prefix}cPosicionY`]
      Zbase = childItem[`${prefix}cPosicionZ`]
    }
  } else if (childItem.handPosition === 'Derecha') {
    if (parentHand === 'CN') {
      const iPosX = childItem[`${prefix}iPosicionX`]
      const dPosX = childItem[`${prefix}dPosicionX`]
      const cPosX = childItem[`${prefix}cPosicionX`]

      Xbase = childItem[`${prefix}dPosicionX`]
      Ybase = childItem[`${prefix}dPosicionY`]
      Zbase = childItem[`${prefix}dPosicionZ`]
    } else if (isCentralHandNormal) {
      Xbase = childItem[`${prefix}iPosicionX`] ?? childItem[`${prefix}cPosicionX`] ?? 0
      Ybase = childItem[`${prefix}iPosicionY`] ?? childItem[`${prefix}cPosicionY`] ?? 0
      Zbase = childItem[`${prefix}iPosicionZ`] ?? childItem[`${prefix}cPosicionZ`] ?? 0
    } else {
      Xbase = childItem[`${prefix}dPosicionX`]
      Ybase = childItem[`${prefix}dPosicionY`]
      Zbase = childItem[`${prefix}dPosicionZ`]
    }
  } else if (childItem.handPosition === 'Normal') {
    const isFirstTirador =
      childItem ===
      Array.from(parentItem.childs || []).find((childID: unknown) => {
        const child = parentItem.items?.get(childID as string)
        return child && (child.description === 'Tirador' || child.typeOfSon === 'Tirador')
      })
    if (isFirstTirador) {
      Xbase = childItem[`${prefix}dPosicionX`] ?? childItem[`${prefix}cPosicionX`] ?? 0
      Ybase = childItem[`${prefix}dPosicionY`] ?? childItem[`${prefix}cPosicionY`] ?? 0
      Zbase = childItem[`${prefix}dPosicionZ`] ?? childItem[`${prefix}cPosicionZ`] ?? 0
    } else {
      Xbase = childItem[`${prefix}iPosicionX`] ?? childItem[`${prefix}cPosicionX`] ?? 0
      Ybase = childItem[`${prefix}iPosicionY`] ?? childItem[`${prefix}cPosicionY`] ?? 0
      Zbase = childItem[`${prefix}iPosicionZ`] ?? childItem[`${prefix}cPosicionZ`] ?? 0
    }
  }
  Xbase = Xbase ?? 0
  Ybase = Ybase ?? 0
  Zbase = Zbase ?? 0
  let x = Xbase
  let y = Ybase
  let z = Zbase

  if (parentItem.tipoNormalizado === 'MBJ') {
    if (childItem.handPosition === 'Centro') {
      x = Xbase + (widthActual - widthBase) / 2
    } else if (childItem.handPosition === 'Derecha' && !isCentralHandNormal) {
      x = Xbase + (widthActual - widthBase)
    } else if (isCentralHandNormal) {
      x = Xbase + (widthActual - widthBase) / 2
    }
    if (isCentralHandNormal) {
      y = Ybase - (heightBase - heightActual)
      z = Zbase - (depthBase - depthActual)
    } else {
      y = Ybase - (heightBase - heightActual)
      z = Zbase - (depthBase - depthActual)
    }
  } else if (parentItem.tipoNormalizado === 'COL' || parentItem.tipoNormalizado === 'MAL') {
    if (parentHand === 'CN') {
      let originalPos = 0

      if (childItem.handPosition === 'Centro' && isTirador) {
        originalPos = childItem[`${prefix}cPosicionX`] ?? 0
      } else if (childItem.handPosition === 'Izquierda') {
        originalPos = childItem[`${prefix}iPosicionX`] ?? 0
      } else if (childItem.handPosition === 'Derecha') {
        originalPos = childItem[`${prefix}dPosicionX`] ?? 0
      }

      if (originalPos !== 0) {
        const ratio = originalPos / widthBase
        x = ratio * widthActual
      } else {
        x = Xbase
      }
    } else {
      if (childItem.handPosition === 'Centro') {
        x = Xbase + (widthActual - widthBase) / 2
      } else if (childItem.handPosition === 'Derecha') {
        x = Xbase + (widthActual - widthBase)
      }
    }

    if (depthActual !== depthBase) {
      z = Zbase - (depthBase - depthActual)
    }
  }

  return { x, y, z }
}
